import DisplayWrapper from "@/components/wrappers/DisplayWrapper";
import { useFilterSearchParams } from "@/utils/hooksUtils";
import { Card, Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { useFilterSpecialCommissions } from "../../../../common/api/queries";
import BackNavigationArrow from "../../../../common/components/views/BackNavigationArrow";
import { TwoLevelEntityIdObject } from "../../../../common/types";
import { formatAgentName } from "../../../agent/utils";
import { SpecialCommissionsFilterPageRequest } from "../../special/types";
import { DEFAULT_FILTER_SPECIAL_COMMISSIONS_QUERY_PARAMS } from "../api";
import { BatchSpecialCommissionFilterForm } from "../components/forms/filter/BatchSpecialCommissionFilterForm";
import { BatchSpecialCommissionTable } from "../components/tables/BatchSpecialCommissionTable";

export const CommissionsBatchSpecialCommissionsContainer = () => {
  const { t } = useTranslation();

  const { id1, id2 } = useParams<TwoLevelEntityIdObject>() as { id1: string; id2: string };

  const searchParams = useFilterSearchParams<SpecialCommissionsFilterPageRequest>({
    params: ["report", "code"],
    defaultQueryParamsObject: DEFAULT_FILTER_SPECIAL_COMMISSIONS_QUERY_PARAMS,
  });

  const { data, isFetching, isError } = useFilterSpecialCommissions({ id1, id2, object: searchParams });

  return (
    <DisplayWrapper itemLoaded={!!data} isError={isError}>
      {data ? (
        <>
          <Card
            className="card-box"
            title={
              <BackNavigationArrow>
                <h2>
                  {t("commissions.batch.titles.manageSpecialCommissions", {
                    agentName: formatAgentName(data.agent),
                  })}
                </h2>
                <span className="sub-header-info normal-font-size">
                  {t("commissions.batch.titles.batchDetail", { name: data.batch.name })}
                </span>
              </BackNavigationArrow>
            }
          >
            <Row justify="center">
              <Col flex="1000px">
                <BatchSpecialCommissionFilterForm searchParams={searchParams} />
              </Col>
            </Row>
          </Card>

          <Card className="card-box">
            <BatchSpecialCommissionTable commissionsPage={data} loading={isFetching} />
          </Card>
        </>
      ) : undefined}
    </DisplayWrapper>
  );
};
